
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { I18nMixin } from '../../mixins';
import { IDiagnosticDiagnosticReinsuranceDefaultI18n, IDiagnosticDiagnosticReinsuranceOverrideI18n } from './types';

import WLDiagnosticReinsuranceBlock from './WLDiagnosticReinsuranceBlock.vue';

@Component({ components: { WLDiagnosticReinsuranceBlock } })
export default class WLDiagnosticReinsurance extends Mixins(I18nMixin) {
  public defaultI18n!: IDiagnosticDiagnosticReinsuranceDefaultI18n;

  @Prop()
  public overrideI18n!: IDiagnosticDiagnosticReinsuranceOverrideI18n;

  @Prop()
  public image1: any;
  @Prop()
  public image2: any;
  @Prop()
  public image3: any;
  @Prop()
  public image4: any;
  @Prop()
  public image5: any;

  created() {
    this.defaultI18n = {
      number_one: this.$t('components_plugin.reinsurance.number_one'),
      no_surprise: this.$t(`components_plugin.reinsurance.no_surprise`),
      customer_service: this.$t(`components_plugin.reinsurance.customer_service`),
      traders_network: this.$t(`components_plugin.reinsurance.traders_network`),
      customer_satisfaction: this.$t(`components_plugin.reinsurance.customer_satisfaction`),
      number_of_interventions: this.$t('components_plugin.reinsurance.number_of_interventions'),
    };
  }
}
